import { useContext } from 'react';
import PropTypes from 'prop-types';

import { MultiStepContext } from './multiStepContext';

const Step = ({ children, stepIndex }) => {
  const { currentStep } = useContext(MultiStepContext);

  return currentStep === stepIndex ? children : null;
};

Step.propTypes = {
  children: PropTypes.node.isRequired,
  stepIndex: PropTypes.number.isRequired,
};

export default Step;
